'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  name: string;
  residential: boolean;
  commercial: boolean;
  packing: boolean;
  assembly: boolean;
}

const ServiceComparison = () => {
  const features: ComparisonFeature[] = [
    {
      name: 'Professional Team',
      residential: true,
      commercial: true,
      packing: true,
      assembly: true,
    },
    {
      name: 'Insurance Coverage',
      residential: true,
      commercial: true,
      packing: true,
      assembly: true,
    },
    {
      name: 'Packing Materials',
      residential: true,
      commercial: true,
      packing: true,
      assembly: false,
    },
    {
      name: 'Furniture Disassembly',
      residential: true,
      commercial: true,
      packing: false,
      assembly: true,
    },
    {
      name: 'Loading & Transport',
      residential: true,
      commercial: true,
      packing: false,
      assembly: false,
    },
    {
      name: 'Unpacking Service',
      residential: true,
      commercial: true,
      packing: true,
      assembly: false,
    },
    {
      name: 'Furniture Assembly',
      residential: true,
      commercial: true,
      packing: false,
      assembly: true,
    },
    {
      name: 'Office Equipment Setup',
      residential: false,
      commercial: true,
      packing: false,
      assembly: true,
    },
    {
      name: 'After-Hours Service',
      residential: false,
      commercial: true,
      packing: false,
      assembly: false,
    },
    {
      name: 'Storage Solutions',
      residential: true,
      commercial: true,
      packing: true,
      assembly: false,
    },
  ];

  return (
    <div className="bg-card rounded-lg shadow-soft overflow-hidden">
      <div className="bg-primary p-6">
        <h2 className="text-2xl font-headline font-bold text-primary-foreground">
          Service Comparison Matrix
        </h2>
        <p className="text-primary-foreground/80 mt-2">
          Compare features across all our moving services
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-muted">
              <th className="px-6 py-4 text-left text-sm font-semibold text-text-primary">
                Feature
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-text-primary">
                Residential
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-text-primary">
                Commercial
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-text-primary">
                Packing
              </th>
              <th className="px-6 py-4 text-center text-sm font-semibold text-text-primary">
                Assembly
              </th>
            </tr>
          </thead>
          <tbody>
            {features.map((feature) => (
              <tr
                key={feature.name}
                className="odd:bg-background even:bg-card"
              >
                <td className="px-6 py-4 text-sm text-text-primary font-medium">
                  {feature.name}
                </td>
                <td className="px-6 py-4 text-center">
                  {feature.residential ? (
                    <Icon
                      name="CheckCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-success mx-auto"
                    />
                  ) : (
                    <Icon
                      name="XCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-text-secondary/30 mx-auto"
                    />
                  )}
                </td>
                <td className="px-6 py-4 text-center">
                  {feature.commercial ? (
                    <Icon
                      name="CheckCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-success mx-auto"
                    />
                  ) : (
                    <Icon
                      name="XCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-text-secondary/30 mx-auto"
                    />
                  )}
                </td>
                <td className="px-6 py-4 text-center">
                  {feature.packing ? (
                    <Icon
                      name="CheckCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-success mx-auto"
                    />
                  ) : (
                    <Icon
                      name="XCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-text-secondary/30 mx-auto"
                    />
                  )}
                </td>
                <td className="px-6 py-4 text-center">
                  {feature.assembly ? (
                    <Icon
                      name="CheckCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-success mx-auto"
                    />
                  ) : (
                    <Icon
                      name="XCircleIcon"
                      size={24}
                      variant="solid"
                      className="text-text-secondary/30 mx-auto"
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceComparison;